import Http from "@/commons/Http";
import VueBusiness from "@/business/VueBusiness";

const path = 'api/documentacao';

export default {

  async pagination(sort, direction, page, size, filters = {}) {
    return Http.post(`${path}/pagination?sort=${sort || 'd.codigo'},${direction || 'asc'}&page=${page || 1}&size=${size || 10}`, filters);
  },

  async paginationV2(sort, direction, page, size, filters = {}){
    return Http.post(`${path}/v2/pagination?sort=${sort || 'd.codigo'},${direction || 'asc'}&page=${page || 1}&size=${size || 10}`, filters);
  },

  nomearEntidade(documentacao){
    return `Documentação`;
  },

  async listar(indicador = '', filtros){
    return Http.post(`${path}/indicador-pessoal/${indicador}`, filtros);
  },

  async getById(indicador){
    return Http.get(`${path}/${indicador}`);
  },

  async save(dto, id = ''){
    return Http.post(`${path}/${id}`, dto);
  },

  async getDocumentacoesPorCodigo(params = {}) {
    const {dto} = params;
    return await Http.post(`${path}/codigos`, dto);
  },

  async vinculos(id){
    return Http.get(`${path}/${id}/vinculos`);
  },

  async setPrincipal(protocoloId, documentacaoId = null, principal = true) {
    return Http.post(`${path}/${protocoloId}/principal`, {documentacaoId, principal});
  },

  tipos(){
    return VueBusiness.getVueRoot().enums?.EnumTipoDocumentacao || []
  },

  isTipo({tipos, valor}) {
    return (tipos || []).includes(valor)
  },

  isProcuracaoOrEscritura(valor) {
    return this.isTipo({tipos: ['ESCRITURA', 'PROCURACAO'], valor})
  },

  isInstrumentoParticular(valor) {
    return this.isTipo({tipos: ['INSTRUMENTO_PARTICULAR'], valor})
  },

  isTipoComCamposCartorariosBase(valor) {
    return this.isTipo({tipos: ['ESCRITURA', 'PROCURACAO', 'INSTRUMENTO_PARTICULAR'], valor})
  },

  isContratoSocial(valor) {
    return this.isTipo({tipos: ['CONTRATO_SOCIAL'], valor})
  },
}
